"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEvents = exports.getAlarm = exports.get = void 0;

var http_1 = require("./http");

var uuid_1 = require("../support/uuid");

var alert_1 = require("../alert");

var uri = '/v5/alarm';

function get(time, credentials, uuid, onlyOngoing, severity) {
  if (uuid === void 0) {
    uuid = uuid_1.EmptyUUID();
  }

  if (onlyOngoing === void 0) {
    onlyOngoing = false;
  }

  if (severity === void 0) {
    severity = alert_1.AlertSeverity.Info;
  }

  var endpoint = uri;

  if (!uuid.equals(uuid_1.EmptyUUID())) {
    var ongoing = "";

    if (onlyOngoing) {
      ongoing = "&ongoing=true";
    }

    endpoint = uri + "/" + uuid.string() + "?severity=" + severity + ongoing;
  }

  return http_1.authorizedHTTP(credentials).get(endpoint, {
    params: {
      time: Math.floor(time.getTime() / 1000)
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.get = get;

function getAlarm(id, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + "/" + id).then(function (resp) {
    return resp.data;
  });
}

exports.getAlarm = getAlarm;

function getEvents(id, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + "/" + id + "/events").then(function (resp) {
    return resp.data;
  });
}

exports.getEvents = getEvents;